import React, {useEffect, useState} from 'react';
import './index.scss'
import {strings} from "../../../strings/strings";
import { AdvertiseOption } from './AdvertiseOption';
import {useMediaQuery} from "@material-ui/core";
import up from '../../../images/travel/grey_arrow_up.svg'
import bottom from '../../../images/travel/grey_arrow_bottom.svg'
import {TravelQuotationPackage} from "../../../model/quoationPackage";

export interface IAdvertiseOption {
    text: string
    type: 'check' | 'plus'
    isMainPackageOption?: boolean
    tooltip?: string,
    isNewOption?: boolean
}

const mainPackTooltipItems: string[] = [
    'Швидка невідкладна допомога',
    'Невідкладна амбулаторна та стаціонарна допомога',
    'Невідкладна стоматологічна допомога',
    'Транспортування до медичного закладу',
    'Медична евакуація із-за кордону',
    'Репатріація тіла',
    'Оплата термінових повідомлень',
    'Оплата ліків'
]

export interface ITravelProgram {
    name: string
    size: 'big' | 'small'
    selected: boolean
    title: string
    price: number
    advertise: IAdvertiseOption[]
    moreDetailsText?: string
    moreDetailsAction?: (event: any) => void
    optionsShow?: number
    onSelectButtonClick: (selectedId: any) => void
}

const TravelProgram: React.FC<ITravelProgram> = ({name, size, selected, title, price, advertise, moreDetailsText, moreDetailsAction, optionsShow, onSelectButtonClick}) => {
    const isMobile = useMediaQuery('(max-width: 1023px)');
    const [options, setOptions] = useState<IAdvertiseOption[]>([])
    const [isShowAll, setIsShowAll] = useState<boolean>(false)

    useEffect(() => {
        if (optionsShow && !isShowAll && isMobile) {
            const items = advertise.filter((item, index) => {
                if (index < optionsShow) {
                    return item
                }
            })
            setOptions(items)
        } else {
            setOptions(advertise)
        }
    }, [isShowAll, isMobile, optionsShow])


    return (
        <div className={`travel-program ${size === 'big' ? 'travel-program-big' : 'travel-program-small'} ${selected ? 'travel-program-selected' : 'travel-program-not-selected'}`}>
            <div className={`travel-program__main-info ${size === 'big' ? 'big-main-info' : 'small-main-info'}`}>
                <h3 className={`travel-program-title-font ${selected ? 'selected-title-font' : 'not-selected-title-font'}`}>{title}</h3>
                <p className={`travel-program-price-font`}>{price + strings.currencyUAH}</p>
                <button onClick={() => onSelectButtonClick(name)} type={'button'} className={`button ${selected ? 'selected-button' : 'not-selected-button'}`}>{selected ? 'Обрана програма' : 'Обрати програму'}</button>
            </div>

            <div className={'travel-program__advertises'}>
                {
                    options?.filter( item => !item.isNewOption)?.map((item) => (
                        !item.isMainPackageOption ?
                        <AdvertiseOption name={item.text}
                                         selected={selected}
                                         iconType={item.type}
                                         tooltip={item?.tooltip ? <p>{item?.tooltip}</p> : null}
                        /> :
                        <AdvertiseOption name={item.text}
                                         selected={selected}
                                         iconType={item.type}
                                         tooltipPlacement={isMobile ? 'bottom' : 'right'}
                                         tooltip={<ul className={'mpTooltip'}>{mainPackTooltipItems.map((item, index) => <li className={'mpTooltip_item'} key={index}>{item}</li>)}</ul>}
                        />
                    ))
                }
                {
                    options?.some( option => option.isNewOption ) && (
                        <>
                            <p className='travel-program__advertises-new_options'>{strings.newOptionsWereAdded}</p>
                            {options?.filter( item => item.isNewOption )?.map( item => (
                                <AdvertiseOption 
                                    name={item.text}
                                    selected={selected}
                                    iconType={item.type}
                                />
                            ))}
                        </>
                    )
                }
                {(optionsShow && isMobile) ?
                    <div className={'openOptions'}>
                        {selected ? <img src={up} alt=""/> : <img src={bottom} alt=""/>}
                        <p onClick={() => {setIsShowAll(!isShowAll)}} className={'showMore-button'}>{!isShowAll ? `Показати ще ${advertise.length - optionsShow} опції` : `Скрити всі опції`}</p>
                    </div>
                    : <></>}
                <small onClick={moreDetailsAction}>{moreDetailsText}</small>
            </div>

        </div>
    );
};

export default TravelProgram